const reloadDuration = (gantt) => {
  gantt.eachTask((task) => {
    task.for_disable_milestone_duration = task.duration;
  });
};

export { reloadDuration };
